export default {
  common: {
    brand_name: "Пирамида Развития",
    child_development_assistance: "Содействие развитию ребенка",
    child_name: "Имя ребенка",
    child_gender: "Пол ребенка",
    child_age: "Возраст ребенка",
    tell_about_child:
      "Расскажите о своем ребенке, чтобы мы могли составить индивидуальный тест для оценки его развития.",
    enter_name: "Введите имя",
    continue: "Далее",
    back: "Назад",
    girl: "Девочка",
    boy: "Мальчик",
    year: {
      one: "год",
      few: "года",
      many: "лет",
      short_unit: "г.",
    },
    month: {
      one: "месяц",
      few: "месяца",
      many: "месяцев",
      short_unit: "мес.",
    },
    year_dative_one: "году",
    year_dative_few: "годам",
    month_dative_one: "месяцу",
    month_dative_few: "месяцам",
    name_required: "Имя обязательно",
    name_too_long: "Имя должно быть не более 10 символов",
    name_invalid_chars: "Имя может содержать только буквы и пробелы",
    email_required: "Email обязателен",
    email_invalid: "Пожалуйста, введите корректный email",
    email_too_long: "Email слишком длинный (максимум 100 символов)",
    email_invalid_chars: "Email содержит недопустимые символы",
    error_title: "Ошибка",
    try_again: "Попробовать снова",
    not_found: "Не найдено",
    error_404_title: "404 Страница не найдена",
    error_404_description: "Эта страница не может быть найдена.",
    error_500_title: "500 Внутренняя ошибка",
    error_500_description: "Что-то пошло не так.",
    start_over: "Начать диагностику сначала",
    error: "Что-то пошло не так, попробуйте позже",
    continue_questionnaire:
      "Ранее вы уже начали проходить опрос, хотите продолжить?",
    continue_button: "Продолжить",
    later_button: "Позже",
    categoryLabel: {
      FineMotor: "Мелкая моторика",
      GrossMotor: "Крупная моторика",
      VisualPerception: "Зрительное восприятие",
      Speech: "Речь",
      HearingPerception: "Слуховое восприятие",
      SocialDevelopment: "Социальное развитие",
    },
    submit: "Отправить",
    skip: "Пропустить",
    next: "Далее",
    close: "Закрыть",
    print: "Распечатать",
    share: "Поделиться",
    male: "Мужской",
    female: "Женский",
    start: "Начать",
    yes: "Да",
    free: "Бесплатно",
    get_free_button: "Получить бесплатно",
    pay_button: "Оплатить",
    enter_button: "Ввести →",
    open_telegram_button: "Открыть Telegram",
    progress_description:
      "Вопросы разбиты на категории и вы можете отслеживать прогресс прохождения теста. По ходу прохождения мы можем добавлять уточняющие вопросы",
    question_instruction: "Прочитайте вопрос и ответьте",
  },
  seo: {
    default_title:
      "Узнайте уровень развития ребенка — бесплатно | Пирамида Развития",
    default_description:
      "Выявите пробелы в развитии вашего малыша, узнайте сильные стороны, получите персональные рекомендации. 10 000 ₽ → Бесплатно. Начать диагностику.",
    fallback_description:
      "Комплексная диагностика развития детей от 0 до 3 лет на базе современных научных данных",
    organization_description:
      "Пирамида Развития — онлайн-платформа для диагностики развития детей от 0 до 3 лет",
    app_category: "Образовательное приложение",
    author_job_title: "Специалист по развитию детей",
    author_name: "Дарина Копенкова",
    og_image_alt:
      "Пирамида Развития - диагностика развития детей от 0 до 3 лет",
    language_code: "ru",
    locale: "ru_RU",
  },
  pages: {
    not_found: "404 - Страница не найдена",
  },
  landing: {
    hero_title:
      "<strong>Выявите пробелы в развитии</strong> вашего малыша, узнайте его <strong>сильные стороны</strong>, получите <strong>персональные рекомендации</strong>",
    price: "10 000 ₽",
    free_for_limited_time: "Бесплатно",
    comprehensive_diagnosis:
      "Комплексная диагностика от 0 до 3 лет по ключевым сферам развития: речь, интеллект, моторика, эмоции, сенсорика, творчество, адаптация.",
    step_1: "Шаг 1",
    step_2: "Шаг 2",
    step_3: "Шаг 3",
    faq_link: "Вопросы и ответы",
    sample_report_link: "Пример отчёта",
    social_subscribe_text:
      "Узнайте больше о развитии детей, играх для развития навыков и получите полезные советы",
    questions_title:
      "Развитие ребёнка — это бесконечные вопросы, сомнения и поиск ответов",
    sample_report: "Пример отчета",
    view_sample_report: "Посмотреть пример отчета",
    report_example_section_description:
      "Посмотрите пример отчета, чтобы увидеть, насколько детальной и персонализированной будет оценка вашего ребёнка",
    comprehensive_diagnosis_title: "Комплексная диагностика",
    comprehensive_diagnosis_subtitle: "развития детей 0–3 лет",
    comprehensive_diagnosis_based: "на базе современных научных данных",
    diagnosis_words_intellectual: "интеллектуального",
    diagnosis_words_physical: "физического",
    diagnosis_words_social: "социального",
    diagnosis_words_emotional: "эмоционального",
    diagnosis_words_speech: "речевого",
    diagnosis_words_sensorimotor: "сенсомоторного",
    diagnosis_words_adaptive: "адаптивного",
    diagnosis_words_creative: "творческого",
    question_1: "Мой ребёнок развивается правильно?",
    question_2: "Должен ли он уже говорить?",
    question_3: "Сидеть без поддержки?",
    question_4: "Уметь ползать?",
    question_5: "Стоять у опоры?",
    question_6: "Понимать просьбы?",
    question_7: "Есть ложкой?",
    question_8: "Задавать вопросы?",
    questions_description:
      "Избавьтесь от постоянных догадок и переживаний.<br/>Получите полную картину развития вашего ребёнка<br/>ответив на простые вопросы",
    start_diagnosis: "Начать диагностику",
    step_1_text: "Укажите пол и возраст ребенка",
    step_2_text:
      'Отвечайте "Да" или "Нет" на персонализированный набор вопросов',
    step_3_text: "Получите уникальный отчет",
    result_title:
      "Вы получите оценку общего уровня развития и развернутый анализ по ключевым сферам, наглядные графики и персональные рекомендации.",
    benefits_title:
      "Вы получите спокойствие, уверенность и план действий зная:",
    benefit_1:
      "На какой возраст сейчас похоже развитие ребёнка в каждой ключевой сфере",
    benefit_2: "Насколько равномерно развиты речь, моторика, мышление и эмоции",
    benefit_3:
      "В чём ребёнок опережает сверстников, а где стоит усилить поддержку",
    benefit_4:
      "Какие шаги сделать дальше — с чёткими, понятными рекомендациями.",
    faq_title: "Отвечаем на главные вопросы родителей:",
    faq_1_q: "С какого возраста можно проходить диагностику?",
    faq_1_a:
      "Подходит для детей от рождения до 3 лет. Вопросы адаптированы под каждый возраст и уровень развития.",
    faq_2_q: "Насколько точно и достоверно работает эта диагностика?",
    faq_2_a:
      "Вопросы и структура разработаны на основе научных подходов к раннему развитию и адаптированы специалистами. Вы получаете качественный ориентир, а не случайные советы из интернета.",
    faq_3_q: "Это онлайн-тест? Нужно ли что-то скачивать?",
    faq_3_a:
      "Всё полностью онлайн. Никаких установок и сложностей — вы просто отвечаете на вопросы в удобном формате.",
    faq_4_q: "Сколько времени занимает прохождение диагностики?",
    faq_4_a:
      "От 10 до 20 минут — в зависимости от возраста и особенностей ребёнка. Вопросы простые и понятные.",
    faq_5_q: "Что будет в отчёте?",
    faq_5_a:
      "Подробная оценка развития по всем ключевым сферам, наглядные графики и персональные рекомендации, адаптированные под возраст.",
    faq_6_q: "Смогу ли я показать отчёт специалисту?",
    faq_6_a:
      "Да, отчёт удобно сохранить, распечатать или переслать. Его можно обсудить с педиатром, неврологом, психологом или воспитателем.",
    faq_7_q: "Это безопасно? Что вы делаете с моими данными?",
    faq_7_a:
      "Все данные защищены. Мы не передаём информацию третьим лицам и используем её только для формирования результата и улучшения сервиса.",
    faq_8_q:
      'У моего ребёнка нет "типичного" развития — стоит ли проходить диагностику?',
    faq_8_a:
      "Да. Диагностика поможет понять текущий уровень развития и даст рекомендации, независимо от темпа и индивидуальных особенностей.",
    faq_9_q: "А если я что-то отвечу неправильно?",
    faq_9_a:
      "Ничего страшного — вопросы простые и интуитивные. А отчёт — это не диагноз, а ориентир для понимания и развития.",
    sharing_1: "Отчёт легко сохранить, переслать или распечатать.",
    sharing_2: "Поделитесь достижениями с близкими или покажите специалисту.",
    personal_plan_title:
      "Хотите получить персональный план развития для вашего ребёнка на основе полученного анализа?",
    app_announcement_title:
      "Мы запускаем приложение с простой, адаптируемой программой развития — под вашего ребёнка.",
    app_announcement_description:
      "Всего 15–30 минут в день на простые игры — и ваш ребёнок будет развиваться быстрее сверстников: в речи, движении, мышлении и не только.",
    it_works_title:
      "Это работает — если развивать навыки последовательно и в нужное время, когда мозг и тело наиболее готовы усваивать их эффективно.",
    it_works_description:
      "Больше не нужно тратить время и деньги на сомнительные занятия или теряться в море разрозненной информации. Не придётся гадать, как увлечь ребёнка и всё ли вы делаете правильно. Просто проводите время вместе — с пользой, интересом и уверенностью. Игры больше не будут пылиться на полках.",
    it_works_alt: "Baby on hand",
    copyright: "Все права защищены.",
    privacy_policy: "Политика конфиденциальности",
    terms_of_use: "Условия использования",
    support: "Поддержка",
    mobile_menu: {
      faq: "Часто задаваемые вопросы",
    },
  },
  questionnaire: {
    error: "Что-то пошло не так, попробуйте позже или начните сначала",
    question_progress: "{{current}} из {{total}}",
    answer_no: "Нет",
    answer_not_sure: "Не уверены?",
    answer_pending: "Пожалуйста, подождите, мы обрабатываем предыдущий ответ",
    answer_error: "У нас что-то пошло не так, попробуйте ответить еще раз",
    completedTitle: "Готово!",
    completedSubtitle1: "Пожалуйста, укажите вашу электронную почту.",
    welcome_title: "🚀 Раскройте потенциал вашего ребёнка",
    welcome_description:
      "📈 Проведите оценку навыков и получите индивидуальную программу развития",
    how_it_works: "Как это работает:",
    step_1: "1. Ответьте на простые вопросы.",
    step_2: "2. Сразу же получите отчёт и персональное расписание занятий.",
    step_3: "3. Следуйте простым инструкциям для каждой активности.",
    time_section: "Время:",
    time_questionnaire: "Заполнение анкеты займёт 5–10 минут.",
    time_activities: "Занимайтесь 1–2 часа в день с ребёнком.",
    result_section: "Результат:",
    result_report: "Подробный отчёт.",
    result_schedule: "Индивидуальное расписание.",
    result_tips: "Полезные советы.",
    result_guarantee: "Гарантированный результат.",
    learn_more: "Подробнее",
    get_acquainted: "Познакомимся!",
    get_acquainted_description:
      "Ответьте на пару вопросов, чтобы мы составили индивидуальный тест для диагностики развития вашего малыша",
    specify_gender: "Укажите пол ребенка",
    specify_age: "Укажите возраст малыша",
    months: "мес.",
    completedSubtitle2:
      "Вы сразу же получите ссылку, по которой в любое время сможете смотреть результаты диагностики",
    email: {
      placeholder: "Ваша электронная почта",
      submit: "Получить результаты",
      verification1:
        "Мы отправили письмо со ссылкой на результаты диагностики на ваш адрес",
      verification2:
        "Если вы не получили письмо, пожалуйста, проверьте папку спам или напишите нам на",
      resend_email: "Отправить письмо повторно",
      rate_limit:
        "Пожалуйста, подождите {{seconds}} секунд перед повторной попыткой",
      email_sent_again: "Письмо с подтверждением отправлено повторно",
      invalid: "Пожалуйста, введите корректный email",
      delivery_time: "Письмо обычно приходит в\u00A0течение 2‑5\u00A0минут",
      check_spam: "💡 Проверьте папку «Спам»",
      change_or_resend: "Изменить email или отправить еще раз",
    },
  },
  results: {
    mdHeaderTitle: "Результаты теста",
    age_gauge_description: "Возраст, соответствующий развитию вашего ребенка",
    read_more: "Читать дальше",
    app_announcement_success:
      "Отлично! Вы в списке первых, кто получит доступ к программе. Мы обязательно сообщим вам, когда она будет готова.",
    app_announcement_description:
      "А сейчас пройдите диагностику, чтобы на основе результатов получить план, когда приложение будет готово",
    start_test: "Начать тест",
    want_personal_plan:
      "Хотите получить индивидуальный план для дальнейшего развития вашего ребенка на основе полученного анализа?",
    want_personal_plan_button: "Хочу персональный план",
    personal_plan_button: "Персональный план",
    start_diagnostic_button: "Пройти диагностику",
    want_app_form: {
      title: "Получить персональный план развития",
      description:
        "Оставьте свой email, и вы в числе первых узнаете о запуске приложения с персональным планом развития",
      email_placeholder: "Ваш email",
      comment_placeholder: "Любой комментарий (необязательно)",
      submit: "Получить план",
    },
  },
  feedback: {
    dialog_title: "Вам понравилась диагностика?",
    dialog_subtitle:
      "Пожалуйста, оцените удобство прохождения опроса и качество отчета, вы поможете нам стать лучше",
    optional_comment:
      "Необязательно: расскажите что вам понравилось и не понравилось…",
  },
  test: {
    consent_text:
      "Я даю согласие на обработку персональных данных моего ребенка (имя, пол, возраст, результаты диагностики) и моих персональных данных (email) для проведения диагностики развития, формирования персональных рекомендаций, отправки результатов на email и информирования о новых возможностях сервиса в соответствии с <a href='/privacy-policy'>Политикой конфиденциальности</a> и <a href='/terms-of-use'>Пользовательским соглашением</a>",
    consent_required: "Примите согласие для продолжения",
    promo_invalid: "Промокод недействителен или уже использован",
  },
  promo: {
    generate_button: "Создать",
    copy_button: "Скопировать",
    copied_new: "Новый промокод скопирован",
    generated: "Промокод создан",
  },
  payment: {
    header_title: "Узнайте сильные стороны вашего ребёнка",
    header_description:
      "Диагностика за 10 минут — получите персональный план развития",
    card_title_telegram: "Telegram",
    dialog_step_1: "Откройте этот пост в Telegram",
    dialog_step_2: "Оставьте под ним любой комментарий",
    dialog_step_3: "Подпишитесь на канал",
    helper_text:
      "Подпишитесь в Telegram → Прокомментируйте → Получите ссылку в ЛС",
    caption_text: "Ссылка с промокодом придёт в личные сообщения",
    icon_comment: "Коммент",
    icon_code_dm: "Код в ЛС",
    dialog_title: "Как получить бесплатно",
    dialog_step_4: "В ЛС придёт ссылка на бесплатную диагностику",
    payment_title: "Оплата",
    payment_price: "1 000 ₽",
    payment_caption: "Моментальный доступ. Чек придёт на e-mail.",
    or_divider: "ИЛИ",
    promo_code_text: "У меня есть промокод",
    privacy_text: "🔒 Данные не публикуем • Доступ сохранится навсегда",
  },
  report: {
    list: {
      need_fast_development: "{{count}} нуждаются в скорейшем развитии",
      mastered_on_time: "{{count}} освоены вовремя",
      mastered_early: "{{count}} навыков освоены раньше сверстников",
    },
    stability_stable:
      "Так держать! Стабильное развитие соответствующее возрасту.",
    stability_ahead:
      "Поздравляем! Ребенок существенно опережает возрастную норму.",
    stability_unstable:
      "Нестабильное развитие: есть опережающие и отстающие группы навыков — подумайте о системном подходе к развитию.",
    stability_behind:
      "Ребенок немного отстает от возрастной нормы — подумайте о введении занятий на развитие отстающих навыков.",
    stability_too_behind:
      "Ребенок существенно отстает от возрастной нормы — подумайте о консультации специалиста и введении занятий на развитие отстающих навыков.",
    stability_too_behind_unstable:
      "Существенное отставание в развитии ключевых возрастных навыков сочетается с отдельными опережающими. Подумайте о консультации специалиста и системном подходе к развитию.",
    overview: {
      title: "Развитие по категориям",
    },
    legend: {
      mastered: "Освоено",
      early: "Освоено раньше",
    },
    labels: {
      advanced_mastered: "Освоено с опережением",
      matching_mastered: "Освоено в срок",
      missing: "Не освоено",
      missing_overdue: "Не освоено, срок нарушен",
      on_time: "Вовремя",
      advanced: "Опережают",
      missed: "Пропущено",
    },
    stats: {
      should_be_mastered_label: "Должно быть освоено к {{age}}",
    },
    words: {
      skill_one: "навык",
      skill_few: "навыка",
      skill_many: "навыков",
    },
    progress: {
      you_mastered: "Вы освоили",
    },
    skills: {
      of_them: "Из них",
      to_master: "Пора осваивать ({{count}})",
      mastered_on_time: "Освоено вовремя ({{count}})",
      mastered_in_advance: "Освоено с опережением ({{count}})",
    },
    conclusions: {
      excellent_title: "Отличное развитие",
      excellent_subtitle: "Опережение возрастных норм:",
      excellent_text:
        "это значит, что в этих категориях навыки развиваются быстрее, чем ожидалось.",
      well_title: "Хорошее развитие",
      well_subtitle: "В соответствии с возрастом:",
      well_text: "навыки развиваются в соответствии с возрастными нормами.",
      steady_title: "Стабильное развитие",
      steady_subtitle: "Требует поддержания темпа:",
      steady_text:
        "навыки развиваются стабильно, важно поддерживать текущий темп.",
      uneven_title: "Непоследовательное развитие",
      uneven_subtitle: "Требует внимания:",
      uneven_text:
        "наблюдаются колебания, что требует дополнительного внимания.",
      critical_title: "Критическое отставание",
      critical_subtitle: "Требует срочного внимания:",
      critical_text:
        "навыки значительно отстают от нормы и требуют немедленного вмешательства.",
    },
    cta: {
      title:
        "✨ Хотите получить персональный план развития для вашего ребёнка на основе полученного анализа? ✨",
      p1: "🚀 Мы запускаем приложение, где индивидуально под вашего ребенка будет составляться и корректироваться простая и понятная программа развития.",
      p2: "⏰ Занимаясь 15–30 минут в день с доступными играми, вы поможете ребёнку догнать и перегнать возрастные нормы в ключевых сферах — интеллект, моторика, речь.",
      p3: "💡 Это работает, если развивать навыки последовательно и вовремя, когда мозг и тело наиболее эффективно усваивают новое.",
      p4: "Больше никаких сомнительных групповых занятий и блуждания в информации — будет чёткий план и понятные действия!",
      p5: "🎯 Проводите время с ребёнком эффективно. Коробки игр больше не будут пылиться!",
    },
    pie: {
      main_text:
        "<0>Ваш ребёнок</0> <1>уже освоил <2>{{totalMastered}}</2></1><3><4>, из них <5>{{advancedMastered}}</5> (<6>{{advancedPercent}}%</6>) освоены раньше сверстников</4></3>",
      missing_text:
        "К сожалению, <0>пока не освоено <1>{{missing}}</1> (<2>{{missingPercent}}%</2>)</0> из <3>{{totalExpected}}</3>. Но уже есть хорошая база, чтобы быстро наверстать.",
    },
    ai_report: {
      print_title: "Общий отчет о развитии навыков",
      print_error:
        "Печать недоступна в данном браузере. Попробуйте использовать другой браузер или скопируйте текст вручную.",
      loading_title:
        "Покажем здесь общее заключение и персональные рекомендации через несколько минут",
      error_title: "Общий отчет о развитии не может быть сейчас загружен",
      error_description:
        "Попробуйте обновить страницу через 30 минут или повторите попытку сейчас",
      error_retry: "Попробовать еще раз",
      not_ready_title: "Общий отчет о развитии пока не готов",
      not_ready_description:
        "Попробуйте обновить страницу через несколько минут",
      not_ready_refresh: "Обновить",
      mastered_on_time: "освоено вовремя",
      percent_mastered_on_time: "процент освоенных вовремя",
      missing_required:
        "неосвоенные, но должны были быть уже освоены к данному возрасту",
      percent_missing_on_time: "процент неосвоенных вовремя",
      mastered_early: "освоенные даже раньше нормативного возраста",
      percent_mastered_early: "процент освоенных раньше нормативного возраста",
      next_to_master: "следующие к освоению",
    },
    share: {
      title: "Отчет о развитии {{name}}",
      text: "Посмотрите результаты оценки развития {{name}}",
    },
    categories_stability: {
      behind_title: "Есть отстающие категории",
      ahead_title: "Опережающее развитие",
      balanced_title: "Сбалансированное развитие",
      balanced_description: "Все категории достаточно развиты",
      behind_lags: "отстают от возрастной нормы",
      behind_lag: "отстает от возрастной нормы",
      behind_with_advanced: "в сочетании с наличием опережающих навыков",
      unstable_developed: "развиты неравномерно",
      unstable_develop: "развита неравномерно",
      stable_sufficient: "достаточно развита",
      stable_sufficient_plural: "достаточно развиты",
      ahead_ahead: "опережает возрастную норму",
      ahead_aheads: "опережают возрастную норму",
      category: "категория",
      categories: "категории",
      categories_many: "категорий",
      though: "хотя",
      and: "и",
      and_yet: "а еще",
    },
  },
  tutorial: {
    if_child_can: "если ребенок может выполнить указанное действие.",
    if_child_cannot:
      "Если ребенок не владеет или владеет навыком только частично - нажмите",
    hint_description:
      'Если вопрос не совсем понятен или вы сомневаетесь, нажмите "не уверены", чтобы прочитать подсказку с критериями ответа на данный вопрос.',
    auto_save: "Каждый ответ",
    auto_save_highlight: "автоматически сохраняется в браузере",
    can_close_and_return:
      "Вы можете в любой момент закрыть вкладку и вернуться к продолжению теста позже, начав с того вопроса, на котором остановились.",
  },
  landing_assets: {
    questionnaire: {
      question_1_name: 'Может исполнить просьбу: "Дай мне два..."',
      question_1_hint:
        'Ребёнок может по просьбе дать определённое количество предметов (например, "Дай мне два кубика", "Дай три мячика"). Понимает числительные "два", "три" и может выполнить соответствующую просьбу.',
      question_2_name:
        "Понимает ли ваш ребёнок названия многих знакомых предметов, людей, некоторых действий (примерно 50–150 слов и более)?",
      question_2_hint:
        "Ребёнок может по просьбе показать или дать знакомый предмет (например, «дай мяч», «где мишка?»), указать на знакомого человека, понять название простого действия («поцелуй маму», «помаши ручкой»). Точный подсчёт сложен, оценивается уверенное понимание многих часто употребляемых слов.",
      question_11_name: "Может словами выразить мысли короткими",
      question_12_name: "Может ли ребенок расстегнуть пуговицу",
      question_13_name:
        "Может взаимодействовать с разными людьми, которые становятся знакомыми",
    },
    report: {
      child_name: "Катя",
    },
  },
};
